<template>
  <div class="dialog-wrap">
    <el-dialog
      title="权限编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="父权限"
          v-if="dataForm.pid"
        >
          <el-input
            v-model="dataForm.parent.title"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入权限名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="编码"
          prop="code"
        >
          <el-input
            v-model="dataForm.code"
            placeholder="请输入权限编码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="type"
        >
          <el-select
            v-model="dataForm.type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            v-model="dataForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminRuleUpdate } from '@/api/admin'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      },
      types: [
        { value: 1, label: '页面' },
        { value: 2, label: '其它' }
      ]
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.dataForm = val
      }
    }
  },
  created() {
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, { status: this.dataForm.status ? 1 : 2 })
          delete params.children
          delete params.parent
          adminRuleUpdate(params).then(res => {
            this.$message.success(`编辑成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
